import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommFlowerIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M11.2703 2.48573C11.7074 2.16996 12.2956 2.17171 12.7312 2.48536L14.6319 3.85413C14.6318 3.85406 14.632 3.8542 14.6319 3.85413C14.7192 3.91668 14.8376 3.9169 14.9248 3.85433C14.9247 3.8544 14.9249 3.85427 14.9248 3.85433L16.3257 2.84542C17.1525 2.25093 18.306 2.84044 18.306 3.86001V7.44401C18.306 10.9273 15.4821 13.75 12 13.75C8.51787 13.75 5.694 10.9273 5.694 7.44401V3.86001C5.694 2.83903 6.84921 2.25142 7.67484 2.84508L9.07591 3.85413C9.07586 3.85409 9.07596 3.85417 9.07591 3.85413C9.1632 3.91681 9.28156 3.91694 9.36886 3.85429L11.2691 2.48656C11.2695 2.48628 11.2699 2.486 11.2703 2.48573ZM12.001 3.80794L13.7557 5.07162C14.3663 5.51078 15.1903 5.51105 15.8009 5.07189L16.806 4.34803V7.44401C16.806 10.0987 14.6539 12.25 12 12.25C9.34613 12.25 7.194 10.0987 7.194 7.44401V4.34731L8.19969 5.0716C8.81031 5.51076 9.63429 5.51105 10.2449 5.07189L12.001 3.80794ZM4.25 14C4.25 13.5858 4.58579 13.25 5 13.25C8.08812 13.25 10.7544 15.0562 12 17.6698C13.2456 15.0562 15.9119 13.25 19 13.25C19.4142 13.25 19.75 13.5858 19.75 14C19.75 18.2802 16.2802 21.75 12 21.75C7.71979 21.75 4.25 18.2802 4.25 14ZM5.80083 14.8008C8.6122 15.1604 10.8396 17.3878 11.1992 20.1992C8.38781 19.8396 6.16041 17.6122 5.80083 14.8008ZM12.8008 20.1992C13.1604 17.3878 15.3878 15.1604 18.1992 14.8008C17.8396 17.6122 15.6122 19.8396 12.8008 20.1992Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
